export const lt = {
    REQUIRED_ACTION_KeepCapturing: 'Tęskite užfiksavimą.',
    REQUIRED_ACTION_PauseCapturing: 'Pauzės užfiksavimas',
    REQUIRED_ACTION_Close: 'Arti',
    REQUIRED_ACTION_Error: 'Klaida',
    REQUIRED_ACTION_AGREE: 'Sutinku',
    REQUIRED_ACTION_DISAGREE: 'Nesutinku',
    LIVENESS_ACTION_Smile: 'Šypsokite',
    LIVENESS_ACTION_Frown: 'Nusiminimas',
    'LIVENESS_ACTION_Tilt Left': 'Pažiūrėk į kairę.',
    'LIVENESS_ACTION_Tilt Right': 'Žiūrėkite į dešinę',
    'LIVENESS_ACTION_Tilt Up': 'Pažiūrėkite aukštyn',
    'LIVENESS_ACTION_Tilt Down': 'Pažvelk žemyn',
    'LIVENESS_ACTION_Look Straight': 'Žiūrėk tiesiai į priekį',
    'LIVENESS_ACTION_No Action': 'Jokio veiksmo',
    LIVENESS_ACTION_PROCESSING_LIVENESS: 'Apdorojimo gyvybingumas',
    'LIVENESS_RESULT_Thank you!.Failed': 'Nepavyko',
    'LIVENESS_RESULT_Thank you!.Passed': 'Praėjo',
    'LIVENESS_RESULT_Thank you!.ActionTimedOut': 'Veiksmas baigėsi laiku.',
    'LIVENESS_RESULT_Thank you!.Interrupted': 'Pertrauktas',
    'LIVENESS_RESULT_Thank you!.Undefined': 'Neapibrėžta',
    LIVENESS_ACTION_LOOK_STRAIGHT_TITLE: 'Žiūrėkite tiesiai į priekį',
    LIVENESS_ACTION_LOOK_STRAIGHT_TEXT: 'Visą laiką žiūrėkite į ekraną',
    LIVENESS_ACTION_LOOK_LEFT_TITLE: 'Šiek tiek pasukite galvą į kairę',
    LIVENESS_ACTION_LOOK_LEFT_TEXT: 'Visą laiką žiūrėkite į ekraną',
    LIVENESS_ACTION_LOOK_RIGHT_TITLE: 'Šiek tiek pasukite galvą į dešinę',
    LIVENESS_ACTION_LOOK_RIGHT_TEXT: 'Visą laiką žiūrėkite į ekraną',
    LIVENESS_ACTION_LOOK_UP_TITLE: 'Šiek tiek pasukite galvą į viršų',
    LIVENESS_ACTION_LOOK_UP_TEXT: 'Visą laiką žiūrėkite į ekraną',
    LIVENESS_ACTION_LOOK_DOWN_TITLE: 'Šiek tiek pasukite galvą žemyn',
    LIVENESS_ACTION_LOOK_DOWN_TEXT: 'Visą laiką žiūrėkite į ekraną',
    LIVENESS_ACTION_SMILE_TITLE: 'Šypsokitės',
    LIVENESS_ACTION_SMILE_TEXT: 'Visą laiką žiūrėkite į ekraną',
    LIVENESS_ACTION_FROWN_TITLE: 'Raukitės',
    LIVENESS_ACTION_FROWN_TEXT: 'Visada žiūrėkite į ekraną',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE: 'Oi... Tu per arti.',
    PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE: 'Oi... Tu per arti.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED: 'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE:
        'Negalime vaizde aptikti veido. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE: 'Oi... Tu per toli.',
    PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE: 'Oi... Kažkas nutiko.',
    ASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES:
        'Negalime vaizde aptikti veido. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE:
        'Oi... Negalime aptikti veido.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN: 'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_INTERNAL: 'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD: 'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_None_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_None: 'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR: 'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE:
        'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE:
        'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE:
        'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE:
        'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE:
        'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_NULLPTR: 'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR: 'Kažkas nutiko. Bandykite dar kartą.',
    PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE: 'Oi... Kažkas ne taip.',
    PASSIVE_LIVENESS_ERROR_INVALID_META: 'Kažkas nutiko. Bandykite dar kartą.',
    INITIALIZING_TITLE: 'Inicijuojama',
    INITIALIZING_DESCRIPTION:
        'Patikrinkite aparatinės įrangos galimybes, prašome palaukti...',
    JOURNEY_STATE_STARTED: 'Pradėta',
    JOURNEY_STATE_INPROGRESS: 'Vykdoma',
    JOURNEY_STATE_ENDED: 'Pabaiga',
    INFO_JOURNEY_STATE: 'Valstybė',
    INFO_JOURNEY_ACTION: 'Veiksmas',
    INFO_JOURNEY_ACTION_ATTEMPT: 'Veiksmo bandymas',
    INFO_JOURNEY_ID: 'Kelionės ID',
    INFO_JOURNEY_RESULT: 'Rezultatas',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE: 'Rezultato pranešimas',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE:
        'Jūsų pateiktas ID buvo pasenęs – pabandykite ką nors kita',
    INFO_JOURNEY_REFERENCE: 'Nuoroda',
    FLOW_STATE_NONE: 'Nė vienas',
    'FLOW_STATE_IDENTITY:FRONT': 'Priekinis Pusė.',
    'FLOW_STATE_IDENTITY:BACK': 'Atgalinis Pusė.',
    FLOW_STATE_ADDRESS: 'Adresas',
    FLOW_STATE_SELFIE: 'Savęs nuotrauka',
    FLOW_STATE_LIVENESS: 'Gyvumas',
    FLOW_STATE_COVID: 'Covid',
    PROVIDER_TITLE_CAMERA: 'Kamera',
    PROVIDER_TITLE_CROPPER: 'Derlius',
    PROVIDER_TITLE_FILESYSTEM_ID: 'Įkelkite savo asmens dokumento nuotrauką',
    PROVIDER_TITLE_FILESYSTEM_FACEMATCH: 'Įkelk savo nuotrauką',
    PROVIDER_TITLE_FILESYSTEM_ADDRESS: 'Įkelkite savo adreso įrodymo nuotrauką',
    PROVIDER_TITLE_FILESYSTEM_COVID:
        'Įkelkite savo „Covid“ dokumento nuotrauką',
    PROVIDER_TITLE_GATEWAY: 'Vartai',
    PROVIDER_TITLE_LIVENESS: 'Gyvumas',
    PROVIDER_TITLE_LOGIN: 'Prisijungti',
    PROVIDER_TITLE_RESULTS: 'Rezultatai',
    PROVIDER_TITLE_SCANNER: 'Nuskaitykite savo asmens dokumentą',
    PROVIDER_TITLE_VIEW_ID: 'Patikrinkite savo asmens dokumento peržiūrą',
    PROVIDER_TITLE_VIEW_FACEMATCH: 'Patikrinkite savo asmenukės peržiūrą',
    PROVIDER_TITLE_VIEW_ADDRESS: 'Patikrinkite adreso įrodymo peržiūrą',
    ROVIDER_TITLE_VIEW_COVID: 'Patikrinkite savo „Covid“ peržiūrą',
    PROVIDER_SUBTITLE_FILESYSTEM_ID:
        'Įkelkite savo asmens dokumento nuotrauką, kuri būtų aiški, sufokusuota, neuždengta ir tiesiai priešais.',
    PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH:
        'Įkelkite savo nuotrauką, kuri yra aiški, sufokusuota, neuždengta ir tiesiai veidu',
    PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS:
        'Įkelkite aiškią, sufokusuotą, neuždengtą ir tiesiai atsuktą dokumento nuotrauką.',
    PROVIDER_SUBTITLE_FILESYSTEM_COVID:
        'Įkelkite aiškią, sufokusuotą, neuždengtą ir tiesiai atsuktą dokumento nuotrauką.',
    PROVIDER_SUBTITLE_SCANNER_ID:
        'Padėkite savo asmens dokumento nuotraukos puslapį ant skaitytuvo puse žemyn.',
    PROVIDER_SUBTITLE_VIEW_ID:
        'Patikrinkite, ar jūsų dokumento peržiūra yra aiški, sufokusuota, neuždengta ir nukreipta tiesiai.',
    PROVIDER_SUBTITLE_VIEW_FACEMATCH:
        'Patikrinkite, ar jūsų asmenukės peržiūra yra aiški, sufokusuota, neuždengta ir nukreipta tiesiai į veidą.',
    PROVIDER_SUBTITLE_VIEW_ADDRESS:
        'Patikrinkite, ar jūsų dokumento peržiūra yra aiški, sufokusuota, neuždengta ir nukreipta tiesiai.',
    PROVIDER_SUBTITLE_VIEW_COVID:
        'Patikrinkite, ar jūsų dokumento peržiūra yra aiški, sufokusuota, neuždengta ir nukreipta tiesiai.',
    PROVIDER_TITLE_SMART_CAPTURE: 'Išmanusis užfiksavimas',
    PROVIDER_TITLE_JOURNEY_SELECT: 'Pasirinkite kelionę',
    PROVIDER_TITLE_TERMS_AND_CONDITIONS: 'Taisyklės ir sąlygos',
    PROVIDER_TITLE_USER_INPUT: 'Užpildykite šią formą',
    FILESYSTEM_SUPPORTED_TYPES_FIRST: 'Priimtini formatai:',
    FILESYSTEM_SUPPORTED_TYPES_LIST: 'JPG, PNG',
    FILESYSTEM_SUPPORTED_TYPES_START_SELFIE: 'Priimtini formatai: JPG, PNG',
    FILESYSTEM_MAX_FILE_SIZE: 'Failo dydis: priimame mažesnius nei',
    FILESYSTEM_MAX_FILE_SIZE_NUMBER: '7,5 MB dydžio failus',
    FILESYSTEM_CHECK_FILE_TOO_BIG:
        'Jūsų failas yra per didelis. Įkelkite mažesnį nei 7,5 MB failą.',
    FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT:
        'Jūsų failas yra netinkamo formato. Įkelkite vieną iš priimtinų formatų.',
    FILESYSTEM_IDENTITY_DOCUMENT: 'Asmens tapatybės dokumentas',
    FILESYSTEM_FACEMATCH: 'Veido rungtynės',
    FILESYSTEM_ADDRESS: 'Adreso įrodymas',
    FILESYSTEM_COVID: 'Covid',
    FILESYSTEM_DRAG_DROP: 'Vilkimas ir nuleidimas',
    FILESYSTEM_OR: 'arba',
    FILESYSTEM_CHOOSE: 'Pasirinkite failą',
    FILESYSTEM_UPLOADING: 'Įkėlimas...',
    TRIPLESCAN_GUIDANCE_TRYAGAIN: 'Pabandykite dar kartą',
    FAILURE_REASON_REFER: 'Jūsų tapatybės dokumentas nebuvo patvirtintas.',
    FAILURE_REASON_EXPIRED:
        'Jūsų asmens tapatybės dokumento galiojimo laikas pasibaigęs.',
    FAILURE_REASON_NOT_ACCEPTED:
        'Jūsų asmens tapatybės dokumentas nėra priimtinas dokumento tipas.',
    FAILURE_REASON_NOT_SUPPORTED:
        'Jūsų tapatybės dokumento nepavyko suklasifikuoti arba jis nėra palaikomas.',
    PLEASE_TRY_AGAIN_REFER: 'Pabandykite dar kartą.',
    PLEASE_TRY_AGAIN_EXPIRED: 'Bandykite dar kartą su galiojančiu dokumentu.',
    PLEASE_TRY_AGAIN_NOT_ACCEPTED:
        'Bandykite dar kartą, naudodami kitą dokumentą.',
    PLEASE_TRY_AGAIN_NOT_SUPPORTED: 'Pabandykite dar kartą.',
    BLUR_CHECK_REASON: 'Neryškumas - dokumentas yra neaiškus;',
    GLARE_CHECK_REASON:
        'Atspindžiai - dokumentas neįskaitomas dėl ryškaus šviesos šaltinio;',
    RESOLUTION_CHECK_REASON:
        'Maža skiriamoji geba - dokumentas tinkamai neužpildo rėmelio;',
    EDGES_CHECK_REASON:
        'Trūksta kraštų - dokumentas netinkamai išdėstytas rėmelyje;',
    VALIDATION_FAILED: 'Patvirtinimas nepavyko',
    VALIDATION_FAILED_REASON_DOC_UNKNOWN: '- dokumentas nežinomas.',
    VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED: '- dokumentas nepriimtas.',
    VALIDATION_FAILED_REASON_DOC_EXPIRED:
        '- dokumento galiojimo laikas baigėsi.',
    PREVIEW_INFO_TITLE_ID: 'Gerų ir blogų nuotraukų pavyzdžiai',
    PREVIEW_INFO_GOOD: 'Geras',
    PREVIEW_INFO_BAD: 'Blogas',
    PREVIEW_INFO_GOOD_EXAMPLE_ID:
        'Nuotrauka yra aiški, sufokusuota ir nukreipta tiesiai į veidą.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID:
        'Nuotraukoje turi matytis visi keturi kampai.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ID: 'Dokumentas neturi būti uždengtas.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID: 'Nuotrauka neturi būti neryški.',
    PREVIEW_INFO_TITLE_FACEMATCH: 'Patarimai, kaip padaryti kokybišką asmenukę',
    PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH:
        '„Selfie“ yra aiškus, fokusuotas ir nukreiptas tiesiai į veidą.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH:
        'Asmenukėje turi būti matomas visas veidas.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH: 'Veidas neturi būti uždengtas.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH: '„Selfie“ neturi būti neryški.',
    PREVIEW_INFO_TITLE_ADDRESS: 'Patarimai, kaip gauti geros kokybės nuotrauką',
    PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS:
        'Nuotrauka yra aiški, sufokusuota ir nukreipta tiesiai į veidą.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS:
        'Nuotraukoje turi matytis visi keturi kampai.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS: 'Dokumentas neturi būti uždengtas.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS: 'Nuotrauka neturi būti neryški.',
    PREVIEW_INFO_TITLE_COVID: 'Patarimai, kaip gauti geros kokybės nuotrauką',
    PREVIEW_INFO_GOOD_EXAMPLE_COVID:
        'Nuotrauka yra aiški, sufokusuota ir nukreipta tiesiai į veidą.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID:
        'Nuotraukoje turi matytis visi keturi kampai.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID: 'Dokumentas neturi būti uždengtas.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID: 'Nuotrauka neturi būti neryški.',
    ATTEMPTS_REMAINING: 'Likusių bandymų skaičius:',
    CAMERA_CAPTURE: 'Įjunkite kamerą',
    CAMERA_CAPTURE_START_BUTTON: 'Paleisti automatinį užfiksavimą',
    CAMERA_CAPTURE_CAPTION:
        'Spustelėkite Pradėti automatinį fotografavimą, kad pradėtumėte',
    CAMERA_PREVIEW_START:
        'Įjunkite fotoaparatą, kad pradėtumėte automatinį fotografavimą',
    CAMERA_CONDITION_BLUR: 'Aptiktas suliejimas',
    CAMERA_CONDITION_CAPTURING: 'Užfiksuoti',
    CAMERA_CONDITION_UPLOADING: 'Įkėlimas...Prašome palaukti',
    CAMERA_CONDITION_ALIGNMENT: 'Dokumentas neįtrauktas į rėmelį',
    CAMERA_CONDITION_GLARE: 'Aptiktas atspindys',
    VERIFYING_TITLE: 'Patikrinimas...',
    PREPARING_PREVIEW_TITLE: 'Parengiamoji peržiūra ...',
    CAMERA_CONDITION_LOW_RESOLUTION: 'Dokumentas per toli',
    CAMERA_LOADING: 'Atidarymo kamera...',
    CAMERA_SMARTCAPTURE_ON: 'AUTOMATINIS UŽFIKSAVIMAS - ĮJUNGTAS',
    CAMERA_SMARTCAPTURE_OFF: 'AUTOMATINIS UŽFIKSAVIMAS - IŠJUNGTAS',
    CAMERA_CAPTURE_FRONT:
        'Padėkite pusę su nuotrauka savo asmens dokumento į rėmelį žemiau.',
    CAMERA_MANUAL_CAPTURE_FRONT:
        'Padėkite savo tapatybės dokumentą rėmelyje ir spustelėkite toliau esantį mygtuką',
    CAMERA_CAPTURE_BACK: 'Padėkite savo tapatybės dokumento nugarėlę į rėmelį.',
    CAMERA_CAPTURE_SELFIE_CAPTION:
        'Padėkite savo veidą ovalyje, žiūrėkite tiesiai į kamerą ir spustelėkite žemiau esantį mygtuką, kad padarytumėte asmenukę.',
    AMERA_CAPTURE_ADDRESS_CAPTION:
        'Padėkite adresą patvirtinantį dokumentą rėmelyje ir spustelėkite toliau esantį mygtuką, kad padarytumėte nuotrauką.',
    CAMERA_CAPTURE_COVID_CAPTION:
        'Padėkite „Covid“ dokumentą rėmelyje ir spustelėkite toliau esantį mygtuką, kad padarytumėte nuotrauką.',
    CAMERA_PREVENT_GLARE_HINT:
        'Perkelkite dokumentą toliau nuo tiesioginių šviesos šaltinių.',
    CAMERA_PREVENT_BLUR_HINT: 'Laikykite dokumentą arba prietaisą stabiliai.',
    CAMERA_PREVENT_LOW_RES_HINT: 'Visiškai įstatykite dokumentą į rėmelį.',
    CROPPER_RETRY: 'Pakartoti',
    CROPPER_UPLOAD: 'Įkelti',
    CROPPER_UPLOADING: 'Įkėlimas...',
    FILESYSTEM_SELECT: 'Pasirinkite',
    FILESYSTEM_DROP_IMAGE: 'arba Pamesti paveikslėlį',
    GATEWAY_CAMERA: 'Įjungta kamera',
    GATEWAY_CANCEL: 'Atšaukti kelionę',
    LIVENESS_START: 'Pradėti gyvybingumą',
    PASSIVE_LIVENESS_START: 'Nufotografuoti',
    LOGIN_USERNAME: 'Vartotojo vardas',
    LOGIN_PASSWORD: 'Slaptažodis',
    LOGIN_SUBMIT: 'Pateikti',
    RESULTS_DOCUMENTS: 'Dokumentai',
    RESULTS_DOCUMENTS_NONE: 'Nerasta',
    RESULTS_DOCUMENT_TYPE: 'Dokumento tipas',
    RESULTS_DOCUMENT_RESULT: 'Dokumento rezultatas',
    RESULTS_EXTRACTED_FIELDS_NONE: 'Rezultatų informacija',
    RESULTS_DETAILS_NONE: 'Nerasta',
    RESULTS_NEW_JOURNEY: 'Pradėti naują kelionę',
    RESULTS_NO_INFORMATION: 'Informacijos apie šią kelionę nėra',
    RESULTS_LOGOUT: 'Atsijungti',
    RESULTS_HIGH_LEVEL_Aborted: 'Atšaukta',
    RESULTS_HIGH_LEVEL_TCCDISAGREE: "Nutrauktos T&C's",
    RESULTS_HIGH_LEVEL_Expired: 'Pasibaigęs',
    RESULTS_HIGH_LEVEL_NotAccepted: 'Nepriskirta',
    RESULTS_HIGH_LEVEL_NotSupported: 'Nepalaikoma',
    RESULTS_HIGH_LEVEL_Notsupported: 'Nepalaikoma',
    RESULTS_HIGH_LEVEL_Passed: 'Praėjo',
    RESULTS_HIGH_LEVEL_Refer: 'Nuoroda',
    RESULTS_HIGH_LEVEL_Undefined: 'Neapibrėžta',
    RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT:
        'Kaupiamas gyvumas rezultatas',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK:
        'Dokumento priekinės pusės tipo patikrinimas',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK:
        'Dokumento atgalinė patikra',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY:
        'Dokumentų blokavimo politika',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY: 'Dokumento galiojimo pabaiga',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT: 'Dokumento palaikymas',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION: 'Dokumento patvirtinimas',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY: 'Dokumento įrodymo politika',
    RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION: 'Facematch Validacija',
    RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE: 'Nepilnamečių taisyklė',
    ESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED: 'Reikia sėkmės',
    RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK:
        '„Covid“ paso suderinamumo tikrinimas',
    RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK: 'Duomenų patikrinimai',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED: 'Nepavyko',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED: 'Nereikia',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED: 'Praėjo',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED: 'Praleistas',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED: 'Nenustatyta',
    ADDITIONAL_CHECKS_DETAILS: 'Papildomi patikrinimai',
    ADDITIONAL_CHECKS_DETAILS_NONE: 'Nerasta',
    ADDITIONAL_CHECKS_DETAIL_DATACHECKS: 'Duomenų patikrinimai',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK: 'Grįžtamieji patikrinimai',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA: 'NETAIKOMA',
    GBG_SCORES: 'GBG balai',
    GBG_TRUST_SCORE: 'GBG pasitikėjimo balas',
    GBG_SCORE: 'GBG balas',
    PREVIEW_TITLE: 'Ar jūsų dokumento nuotrauka aiški?',
    VIEW_RETRY: 'PAIMTI NUOTRAUKĄ DAR KARTĄ',
    VIEW_RETRY_DESKTOP: 'Pokyčių nuotrauka',
    VIEW_CROP: 'Derlius',
    VIEW_CROPPING: 'Apkirpti...',
    VIEW_UPLOAD: 'Įkelti',
    VIEW_UPLOAD_PREVIEW: 'TAIP, TĘSTI',
    VIEW_UPLOADING: 'Įkėlimas...',
    SMART_CAPTURE_INITIALIZING: 'Pradėti',
    SMART_CAPTURE_START:
        'Inicijuojamas išmanusis užfiksavimas, Prašome palaukti...',
    SCANNER_DESC_AVAILABLE:
        'Skenavimo prietaisas yra pasiekiamas. Padėkite savo dokumentą į skenerį.',
    SCANNER_DESC_PROCESSING: 'Vaizdas yra apdorojamas serverio.',
    SCANNER_DESC_SCANNING: 'Vaizdas yra nuskaitytas įrenginiu.',
    SCANNER_DESC_DISCONNECTED: 'Skaneris atjungtas nuo tinklo.',
    SCANNER_DESC_NOT_CONNECTED: 'Skaneris nėra prijungtas.',
    SCANNER_DESC_OFFLINE:
        'Skenavimo prietaisas yra neprisijungęs prie interneto.',
    SCANNER_DESC_BUSY:
        'Skenavimo prietaisas naudojamas kitos naudotojo jūsų vietiniame tinkle.',
    SCANNER_DESC_WAITING: 'Laukiama, kol bus nustatytas ryšys.',
    SCANNER_DESC_LOADING: 'Prašome palaukti...',
    SCANNER_TITLE_SCANNING: 'SKANAVIMAS...',
    SCANNER_TITLE_DISCONNECTED: 'ATJUNGTAS',
    SCANNER_TITLE_NOT_CONNECTED: 'NEPRIJUNGTA',
    SCANNER_TITLE_OFFLINE: 'Skeneris neprisijungęs',
    SCANNER_TITLE_BUSY: 'Skeneris užimtas',
    SCANNER_TITLE_WAITING: 'LAUKIANT',
    SCANNER_ACTION_REGISTER: 'Registruotis',
    SCANNER_ACTION_RELEASE: 'Išleidimas',
    CANCEL_JOURNEY: 'Atšaukti',
    MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE: 'Vietoj to įkelkite nuotrauką',
    MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE: 'Vietoj to padarykite nuotrauką',
    JOURNEY_SELECT_CONTINUE: 'Tęsti',
    HELP_MODAL_AUTOCAPTURE_TITLE:
        'Kaip nufotografuoti asmens tapatybės dokumentą',
    HELP_MODAL_AUTOCAPTURE_SUBTITLE:
        'Kai įjungta automatinio fotografavimo funkcija, fotografavimo ekranas automatiškai nufotografuos jūsų dokumentą, kai atpažins, kad jis yra pakankamai geros kokybės.',
    HELP_MODAL_AUTOCAPTURE_TIPS:
        'Patarimai, kaip padaryti geros kokybės nuotrauką',
    HELP_MODAL_AUTOCAPTURE_GLARE_TITLE: 'Apsaugokite nuo atspindžių',
    HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE:
        'Perkelkite dokumentą toliau nuo tiesioginių šviesos šaltinių.',
    HELP_MODAL_AUTOCAPTURE_FAR_TITLE: 'Dokumentas per toli',
    AUTOCAPTURE_FAR_SUBTITLE: 'Visiškai sutalpinkite dokumentą į rėmelį.',
    AUTOCAPTURE_BLUR_TITLE: 'Užkirskite kelią neryškumui',
    HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE:
        'Laikykite dokumentą arba prietaisą stabiliai.',
    HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE:
        'Vis dar susiduriate su sunkumais? Fotografuokite naudodami rankinį fotografavimą',
    HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE: 'Rankinis fotografavimas',
    HELP_MODAL_SELFIE_TITLE: 'Kaip padaryti asmenukę',
    HELP_MODAL_SELFIE_SUBTITLE:
        'Žiūrėkite tiesiai į fotoaparatą ir spustelėkite rankinio fotografavimo mygtuką.',
    HELP_MODAL_POA_TITLE: 'Kaip nufotografuoti adresą patvirtinantį dokumentą',
    HELP_MODAL_POA_SUBTITLE:
        'Padėkite dokumentą rėmelyje ir spustelėkite fotografavimo mygtuką, kad nufotografuotumėte dokumentą.',
    HELP_MODAL_POA_TIPS: 'Patarimai, kaip padaryti geros kokybės nuotrauką',
    HELP_MODAL_POA_GLARE_TITLE: 'Apsaugokite nuo atspindžių',
    HELP_MODAL_POA_GLARE_SUBTITLE:
        'Perkelkite dokumentą toliau nuo tiesioginių šviesos šaltinių.',
    HELP_MODAL_POA_FAR_TITLE: 'Per tolimas dokumentas',
    HELP_MODAL_POA_FAR_SUBTITLE: 'Dokumentą visiškai sutalpinkite į rėmelį.',
    HELP_MODAL_POA_BLUR_TITLE: 'Užkirskite kelią neryškumui',
    HELP_MODAL_POA_BLUR_SUBTITLE:
        'Laikykite dokumentą arba prietaisą stabiliai.',
    HELP_MODAL_POA_MANUAL_CAPTURE:
        'Vis dar kyla sunkumų? Įjunkite rankinį fotografavimą',
    HELP_MODAL_POA_TURN_MANUAL_CAPTURE: 'Rankinis fotografavimas',
    HELP_MODAL_COVID_TITLE: 'Kaip nufotografuoti „Covid“ dokumentą',
    HELP_MODAL_COVID_SUBTITLE:
        'Padėkite dokumentą rėmelyje ir spustelėkite fotografavimo mygtuką, kad nufotografuotumėte dokumentą.',
    HELP_MODAL_COVID_TIPS: 'Patarimai, kaip padaryti geros kokybės nuotrauką',
    HELP_MODAL_COVID_GLARE_TITLE: 'Apsaugokite nuo atspindžių',
    HELP_MODAL_COVID_GLARE_SUBTITLE:
        'Perkelkite dokumentą toliau nuo tiesioginių šviesos šaltinių.',
    HELP_MODAL_COVID_FAR_TITLE: 'Dokumentas per toli',
    HELP_MODAL_COVID_FAR_SUBTITLE: 'Visiškai įstatykite dokumentą į rėmelį.',
    HELP_MODAL_COVID_BLUR_TITLE: 'Išvengti neryškumo',
    HELP_MODAL_COVID_BLUR_SUBTITLE:
        'Laikykite dokumentą arba prietaisą stabiliai.',
    HELP_MODAL_COVID_MANUAL_CAPTURE:
        'Vis dar susiduriate su sunkumais? Įjunkite rankinį fotografavimą',
    HELP_MODAL_COVID_TURN_MANUAL_CAPTURE: 'Rankinis fiksavimas',
    HELP_MODAL_NEED_HELP: 'Pagalba ir parinktys',
    EXCEPTION: 'Įvyko netikėta išimtis',
    EXCEPTION_AUTHORIZATION: 'Neįgaliotas',
    EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED:
        'Jūsų paskyra nėra įgaliota naudotis šiuo ištekliu',
    EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID:
        'Vartotojo vardo ir slaptažodžio derinys negalioja',
    EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED:
        'Norėdami naudotis šia funkcija, turite įjungti autentifikavimą',
    EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED:
        'Jūs nesate įgaliotas šiam procesui',
    EXCEPTION_BAD_REQUEST: 'Bloga užklausa su būsenos kodu 400',
    EXCEPTION_BAD_REQUEST_INVALID_IMAGE: 'Netinkamas vaizdas',
    EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE: 'Kelionė laukia atsakymo',
    EXCEPTION_FLOW_STATE_JOURNEY_ENDED:
        'Negalima siųsti užklausų. Kelionė baigėsi',
    EXCEPTION_FLOW_STATE_MISSING: 'Srauto būsena nerasta',
    EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION:
        'Atgalinis iškvietimas turi būti galiojanti funkcija',
    EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING:
        'Įvykio pavadinimas turi būti eilutės reikšmė.',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER:
        'Prioritetas turi būti skaičius',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER:
        'Prioritetas turi būti teigiamas skaičius',
    EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR:
        'Konteineris turėtų būti arba elementas, arba selektorius.',
    EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID: 'Reikšmė yra netinkama',
    EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED: 'Reikšmė buvo pažeista',
    EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING:
        'Konfigūracija turėtų įtraukti backendUrl parametrą.',
    EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING:
        'Pateikti parametrai turi būti koordinatės.',
    EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING:
        'Pateikti parametrai turi būti paveikslėliai.',
    EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING:
        'Pateikti parametrai turėtų būti slaptažodis.',
    EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING:
        'Pateikti parametrai turėtų būti vartotojo vardas.',
    EXCEPTION_MISSING_REQUIRED_FIELD_MISSING:
        'Užpildykite visus privalomus laukus',
    EXCEPTION_POSTCODE_FORMAT_ERROR:
        'Pašto kodo formatas negalioja minLength:5 / maxLength:8',
    EXCEPTION_HOUSENUMBER_FORMAT_ERROR:
        'Namo pavadinimo / numerio formatas negalioja minDilgis:1 / maxDilgis:20',
    EXCEPTION_STREETNAME_FORMAT_ERROR:
        'Gatvės pavadinimas negalioja minDilgis:1 / maxDilgis:30',
    EXCEPTION_TOWN_FORMAT_ERROR:
        'Miesto formatas negalioja minLength:1 / maxLength:20',
    EXCEPTION_JOURNEY_DEFINITIONS_MISSING:
        'Šiam kanalui nėra kelionės apibrėžčių',
    EXCEPTION_NETWORK:
        'Įvyko tinklo išimtis, patikrinkite savo ryšį ir bandykite dar kartą',
    EXCEPTION_PLATFORM_BROWSER_ONLY:
        'Šią funkciją galima naudoti tik naršyklėje',
    EXCEPTION_PLATFORM_UNSUPPORTED: 'Jūsų aplinka nepalaiko šios funkcijos',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED:
        'Kameros leidimai nesuteikti, patikrinkite naršyklės nustatymus',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE:
        'Kameros leidimai neprieinami',
    EXCEPTION_PLATFORM_CAMERA_NOT_READABLE:
        'Prie kameros nepavyko prisijungti. Uždarykite visas kitas programas ir bandykite dar kartą',
    EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE:
        'Jūsų prietaise tinkamų fotoaparatų nerasta',
    EXCEPTION_SERVER: 'Užklausa nepavyko, būsenos kodas 500',
    EXCEPTION_SERVER_UNREACHABLE: 'Užklausa nepavyko, serveris nepasiekiamas',
    EXCEPTION_SERVER_DATA_NOT_PERSISTED:
        'Proceso metu įvyko klaida. Jūsų duomenys gali būti neišsaugoti',
    EXCEPTION_SERVER_RESULT_NOT_PASSING: 'Dabartinis rezultatas neperduodamas',
    EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE:
        'Canvas kontekstas neprieinamas',
    EXCEPTION_TEMPLATE_CONTAINER_MISSING: 'Konteinerio nėra',
    EXCEPTION_TEMPLATE_ELEMENTS_MISSING: 'Trūksta privalomų elementų',
    EXCEPTION_TEMPLATE_MISSING: 'Šablonas nerastas',
    EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING:
        'Nepavyksta rasti šaltinio elemento',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE:
        'Negalima gauti įvesties teikėjų',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED:
        'Nenurodyti jokie įvesties paslaugų teikėjai',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE: 'Įvesties teikėjo nėra',
    'SUPPORTED_DOCUMENT_Account Statement': 'Sąskaitos išrašas',
    'SUPPORTED_DOCUMENT_Agreement (Tenancy)': 'Sutartis (Nuomos sutartis)',
    'SUPPORTED_DOCUMENT_Bank Document': 'Banko dokumentas',
    'SUPPORTED_DOCUMENT_Bank Letter': 'Banko laiškas',
    'SUPPORTED_DOCUMENT_Bank Statement': 'Banko išrašas',
    'SUPPORTED_DOCUMENT_Benefit Letter': 'Naudos laiškas',
    'SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)':
        'Liudijimas (Gimimo, Santuokos, Civilinio partnerystės)',
    'SUPPORTED_DOCUMENT_Council Document': 'Tarybos dokumentas',
    'SUPPORTED_DOCUMENT_Council Letter': 'Tarybos laiškas',
    'SUPPORTED_DOCUMENT_Council Tax': 'Tarybos mokestis',
    'SUPPORTED_DOCUMENT_Driving License': 'Vairuotojo pažymėjimas',
    'SUPPORTED_DOCUMENT_Driving Licence': 'Vairuotojo pažymėjimas',
    'SUPPORTED_DOCUMENT_DWP Document': 'DWP Dokumentas',
    'SUPPORTED_DOCUMENT_HMRC Document': 'HMRC Dokumentas',
    'SUPPORTED_DOCUMENT_Information Sheet': 'Informacinis lapas',
    'SUPPORTED_DOCUMENT_Insurance Document': 'Draudimo dokumentas',
    'SUPPORTED_DOCUMENT_Insurance Letter': 'Draudimo laiškas',
    SUPPORTED_DOCUMENT_Invoice: 'Sąskaita.',
    'SUPPORTED_DOCUMENT_NIC Letter': 'NIC laiškas',
    'SUPPORTED_DOCUMENT_NINO Letter': 'NINO laiškas',
    'SUPPORTED_DOCUMENT_Official Document': 'Oficialus dokumentas',
    'SUPPORTED_DOCUMENT_Official Letter': 'Oficialus laiškas',
    'SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)':
        'Atsiskaitymo laiškas (susijęs su mokesčiais ar socialine parama)',
    'SUPPORTED_DOCUMENT_Tax Letter': 'Mokesčių laiškas',
    'SUPPORTED_DOCUMENT_Tax Statement': 'Mokesčių pareiškimas',
    'SUPPORTED_DOCUMENT_Tel Bill': 'Tel Bill',
    'SUPPORTED_DOCUMENT_Tel Letter': 'Tel Laiškas',
    'SUPPORTED_DOCUMENT_Telecommunication Document':
        'Telekomunikacijų dokumentas',
    'SUPPORTED_DOCUMENT_TV Licence': 'Televizijos licencija',
    'SUPPORTED_DOCUMENT_University Letter': 'Universiteto laiškas',
    'SUPPORTED_DOCUMENT_Utility Bill': 'Naudos sąskaita',
    'SUPPORTED_DOCUMENT_Utility Document': 'Naudojimo dokumentas',
    'SUPPORTED_DOCUMENT_Utility Letter': 'Naudos laiškas',
    'SUPPORTED_DOCUMENT_Water Bil': 'Vandens skaitiklis',
    'SUPPORTED_DOCUMENT_Water Document': 'Vandens dokumentas',
    'SUPPORTED_DOCUMENT_Agents License': 'Agento licencija',
    'SUPPORTED_DOCUMENT_Electoral Card': 'Rinkimų kortelė',
    'SUPPORTED_DOCUMENT_Foreigner Identification Card':
        'Užsieniečio tapatybės kortelė',
    'SUPPORTED_DOCUMENT_Health Card': 'Sveikatos kortelė',
    'SUPPORTED_DOCUMENT_Job License': 'Darbo licencija',
    'SUPPORTED_DOCUMENT_Membership Identification Card':
        'Narystės identifikacinė kortelė',
    'SUPPORTED_DOCUMENT_Military Identification Card':
        'Karinis identifikacinis kortelė',
    'SUPPORTED_DOCUMENT_National Identification Card':
        'Nacionalinis tapatybės kortelė',
    SUPPORTED_DOCUMENT_Passport: 'Pasas',
    'SUPPORTED_DOCUMENT_Travel Permit': 'Kelionės leidimas',
    SUPPORTED_DOCUMENT_Visa: 'Visa',
    'SUPPORTED_DOCUMENT_Weapons Licence': 'Ginklų licencija',
    'SUPPORTED_DOCUMENT_Selfie Photo': 'Savęs nuotrauka',
    SUPPORTED_DOCUMENT_Unknown: 'Nežinomas',
    SUPPORTED_DOCUMENT_COVIDPAS: 'Covid pass',
    EXTRACTED_FIELDS_AddressFull: 'Adresas Pilnas',
    EXTRACTED_FIELDS_AddressCity: 'Adresas Miestas',
    EXTRACTED_FIELDS_AddressPostCode: 'Adreso pašto kodas',
    EXTRACTED_FIELDS_LastNameFirstPart: 'Pavardė Pirmoji Dalis',
    EXTRACTED_FIELDS_Sex: 'Lytis',
    EXTRACTED_FIELDS_BirthPlace: 'Gimimo vieta',
    EXTRACTED_FIELDS_IssueNumber: 'Leidimo numeris',
    EXTRACTED_FIELDS_DocumentNumberCheckDigit:
        'Dokumento numerio kontrolinis skaitmuo',
    EXTRACTED_FIELDS_BirthDate: 'Gimimo data',
    EXTRACTED_FIELDS_DocumentNumber: 'Dokumento numeris',
    EXTRACTED_FIELDS_FirstName: 'Vardas',
    EXTRACTED_FIELDS_ArbitraryDigit: 'Atsitiktinis skaitmuo',
    EXTRACTED_FIELDS_FirstNameInitial: 'Vardo pradžios raštas',
    EXTRACTED_FIELDS_ExpiryDate: 'Galiojimo data',
    EXTRACTED_FIELDS_IssueDate: 'Išleidimo data',
    EXTRACTED_FIELDS_LastName: 'Pavardė',
    EXTRACTED_FIELDS_LicenseCategory: 'Licencijos kategorija',
    EXTRACTED_FIELDS_DocumentCategory: 'Dokumento kategorija',
    EXTRACTED_FIELDS_DocumentType: 'Dokumento tipas',
    EXTRACTED_FIELDS_NationalityCode: 'Tautybės kodas',
    EXTRACTED_FIELDS_MiddleName: 'Vardas',
    EXTRACTED_FIELDS_FirstIssuanceDate: 'Pirmosios išleidimo datos',
    EXTRACTED_FIELDS_SecondLastName: 'Antrasis Pavardė',
    EXTRACTED_FIELDS_FullName: 'Pilnas vardas',
    EXTRACTED_FIELDS_PersonalNumber: 'Asmens kodas',
    EXTRACTED_FIELDS_NationalityName: 'Pilietybė',
    EXTRACTED_FIELDS_BarcodeItems: 'Barkodas',
    EXTRACTED_FIELDS_BirthPlaceCity: 'Gimimo miestas',
    EXTRACTED_FIELDS_BirthPlaceState: 'Gimimo valstybė',
    EXTRACTED_FIELDS_BirthPlaceCountry: 'Gimimo šalis',
    EXTRACTED_FIELDS_MRZFull: 'Pilnas MRZ',
    EXTRACTED_FIELDS_MRZLine1: 'MRZ Eilutė 1',
    EXTRACTED_FIELDS_MRZLine2: 'MRZ Eilutė 2',
    EXTRACTED_FIELDS_MRZLine3: 'MRZ Eilutė 3',
    EXTRACTED_FIELDS_ObservationPage: 'Stebėjimo puslapis',
    EXTRACTED_FIELDS_IssuingAuthority: 'Išdavimo institucija',
    EXTRACTED_FIELDS_IssuingLocation: 'Išdavimo vieta',
    EXTRACTED_FIELDS_MaritalStatus: 'Santuokinis statusas',
    EXTRACTED_FIELDS_Occupation: 'Užimtumas',
    EXTRACTED_FIELDS_AlienNumber: 'Svetimasis skaičius',
    EXTRACTED_FIELDS_Employer: 'Darbdavys',
    EXTRACTED_FIELDS_AddressLine1: 'Adreso eilutė 1',
    EXTRACTED_FIELDS_AddressLine2: 'Adreso eilutė 2',
    EXTRACTED_FIELDS_AddressLine3: 'Adreso eilutė 3',
    EXTRACTED_FIELDS_AddressLine4: 'Adreso eilutė 4',
    EXTRACTED_FIELDS_AddressState: 'Valstybė',
    EXTRACTED_FIELDS_AddressDistrict: 'Apskritis',
    EXTRACTED_FIELDS_AddressBuildingNumber: 'Pastato numeris',
    EXTRACTED_FIELDS_AddressBuildingName: 'Pastato pavadinimas',
    EXTRACTED_FIELDS_AddressStreet: 'Gatvė',
    EXTRACTED_FIELDS_AddressCountry: 'Šalis',
    EXTRACTED_FIELDS_RefAddressFull: 'Nuorodos adresas',
    EXTRACTED_FIELDS_RefAddressLine1: 'Nuorodos Adresas Eilutė 1',
    EXTRACTED_FIELDS_RefAddressLine2: 'Nuorodos Adreso Eilutė 2',
    EXTRACTED_FIELDS_RefAddressLine3: 'Nuorodos Adreso Eilutė 3',
    EXTRACTED_FIELDS_RefAddressLine4: 'Nuorodos adresas eilutė 4',
    EXTRACTED_FIELDS_RefAddressCity: 'Nuorodos Adresas Miestas',
    EXTRACTED_FIELDS_RefAddressState: 'Nuorodos Adresas Valstybė',
    EXTRACTED_FIELDS_RefAddressDistrict: 'Nuorodos Adresas Apskritis',
    EXTRACTED_FIELDS_RefAddressBuildingNumber:
        'Nuorodos Adreso Pastato Numeris',
    EXTRACTED_FIELDS_RefAddressBuildingName:
        'Nuorodos Adresas Pastato Pavadinimas',
    EXTRACTED_FIELDS_RefAddressSubBuildingName:
        'Nuorodos adresas Papildomo pastato pavadinimas',
    EXTRACTED_FIELDS_RefAddressStreet: 'Referencijos adreso gatvė',
    EXTRACTED_FIELDS_RefAddressCountry: 'Nuorodos Adresas Šalis',
    EXTRACTED_FIELDS_RefAddressPostCode: 'Nuorodos Adresas Pašto Kodas',
    EXTRACTED_FIELDS_HealthNumber: 'Sveikatos numeris',
    EXTRACTED_FIELDS_Endorsements: 'Palaikymai',
    EXTRACTED_FIELDS_Constraints: 'Apribojimai',
    EXTRACTED_FIELDS_LicenseMarine: 'Licencija jūra',
    EXTRACTED_FIELDS_Height: 'Aukštis',
    EXTRACTED_FIELDS_Weight: 'Svoris',
    EXTRACTED_FIELDS_HairColor: 'Plaukų spalva',
    EXTRACTED_FIELDS_EyeColor: 'Akių spalva',
    EXTRACTED_FIELDS_LensData: 'Regėjimas',
    EXTRACTED_FIELDS_SocialSecurityNumber: 'Asmens kodas',
    EXTRACTED_FIELDS_NationalInsuranceNumber: 'Nacionalinis draudimo numeris',
    EXTRACTED_FIELDS_Race: 'Lenktynės',
    EXTRACTED_FIELDS_MotherName: 'Mamos vardas',
    EXTRACTED_FIELDS_FatherName: 'Tėvo vardas',
    EXTRACTED_FIELDS_Parents: 'Tėvai',
    EXTRACTED_FIELDS_Remarks: 'Pastabos',
    EXTRACTED_FIELDS_DistinguishingMarks: 'Skirtieji ženklai',
    EXTRACTED_FIELDS_PeriodOfStay: 'Laikotarpis, kai apsistojama',
    EXTRACTED_FIELDS_TaxNumber: 'Mokesčių numeris',
    EXTRACTED_FIELDS_Donor: 'Rengėjas',
    EXTRACTED_FIELDS_RFIDG1: 'RFID Šiurkštus Duomenų Grupė 1',
    EXTRACTED_FIELDS_RFIDG2: 'RFID Šiurkščiavimo duomenų grupė 2',
    EXTRACTED_FIELDS_RFIDG3: 'RFID Šiurkštus Duomenų Grupė 3',
    EXTRACTED_FIELDS_RFIDG15: 'RFID Žaliava Grupė 4',
    EXTRACTED_FIELDS_RFIDSOD: 'RFID Neapdoroti Duomenys Grupė 5',
    EXTRACTED_FIELDS_PortraitPhoto: 'Ištraukta portreto nuotrauka',
    EXTRACTED_FIELDS_Title: 'Pavadinimas',
    EXTRACTED_FIELDS_IssueDate2: 'Antrasis išleidimo data',
    EXTRACTED_FIELDS_ExpiryDate2: 'Antra galiojimo data',
    EXTRACTED_FIELDS_LicenseCategory2: 'Antra licencijos kategorija',
    EXTRACTED_FIELDS_IssueDate3: 'Trečiasis išleidimo data',
    EXTRACTED_FIELDS_ExpiryDate3: 'Trečias galiojimo laikas',
    EXTRACTED_FIELDS_LicenseCategory3: 'Trečioji licencijos kategorija',
    EXTRACTED_FIELDS_IssueDate4: 'Ketvirtas išleidimo data',
    EXTRACTED_FIELDS_ExpiryDate4: 'Ketvirtasis galiojimo pabaigos data',
    EXTRACTED_FIELDS_LicenseCategory4: 'Ketvirta licencijos kategorija',
    EXTRACTED_FIELDS_MRZCode1: 'MRZ Kodas 1',
    EXTRACTED_FIELDS_MRZCode2: 'MRZ Kodas 2',
    EXTRACTED_FIELDS_MRZStandardType: 'MRZ standartinis tipas',
    EXTRACTED_FIELDS_AddressStreetSuffix: 'Gatvės pabaiga',
    EXTRACTED_FIELDS_AddressStreetType: 'Gatvės tipas',
    EXTRACTED_FIELDS_AddressUnitNumber: 'Adreso vieneto numeris',
    EXTRACTED_FIELDS_LicenseNumber: 'Licencijos numeris',
    EXTRACTED_FIELDS_AddressStateCode: 'Valstybės kodas',
    EXTRACTED_FIELDS_AddressStreetTypeAbbreviation: 'Gatvės santrumpa',
    EXTRACTED_FIELDS_AddressUnitType: 'Adreso vieneto tipas',
    EXTRACTED_FIELDS_AddressDeliveryPointIdentifier:
        'Pristatymo taško identifikatorius',
    EXTRACTED_FIELDS_AgeCategory: 'Amžiaus kategorija',
    EXTRACTED_FIELDS_ChildernCount: 'Vaikų skaičius',
    EXTRACTED_FIELDS_EntryMode: 'Įvedimo režimas',
    EXTRACTED_FIELDS_VAFNumber: 'VAF numeris',
    EXTRACTED_FIELDS_AddressLine5: 'Adreso eilutė 5',
    EXTRACTED_FIELDS_RFIDPortraitPhoto: 'RFID Portretas Nuotrauka',
    EXTRACTED_FIELDS_RefAddressLine5: 'Nuorodos adresas eilutė 5',
    EXTRACTED_FIELDS_RefAddressStateCode: 'Nuorodos Adresas Valstybė',
    EXTRACTED_FIELDS_RefAddressStreetType: 'Nuorodos Adreso Gatvės Tipas',
    EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation:
        'Nuorodos Adreso Gatvės Tipo Santrumpa',
    EXTRACTED_FIELDS_RefAddressStreetSuffix:
        'Referencijos Adreso Gatvės Pabaiga',
    EXTRACTED_FIELDS_RefAddressUnitNumber: 'Nuorodos Adreso Vieta Numeris',
    EXTRACTED_FIELDS_RefAddressUnitType: 'Nuorodos Adreso Vieneto Tipas',
    EXTRACTED_FIELDS_RefAddressPostcodeType:
        'Nuorodos Adresas Pašto Kodas Tipas',
    EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier:
        'Nuorodos adreso pristatymo taško identifikatorius',
    EXTRACTED_FIELDS_RefAddressPOBoxNumber:
        'Referencijos adreso pašto dėžutės numeris',
    EXTRACTED_FIELDS_RefAddressDependentLocality:
        'Nuorodos adresas priklausomas nuo vietovės',
    EXTRACTED_FIELDS_RefAddressDoubleDependentLocality:
        'Nuorodos adresas Dviguba priklausoma vietovė',
    EXTRACTED_FIELDS_RefAddressThoroughfare: 'Referencijos Adreso Gatvė',
    EXTRACTED_FIELDS_RefAddressThoroughfareDesc:
        'Nuorodos Adreso Gatvės Aprašymas',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfare:
        'Nuorodos Adresas Priklausomas Kelią',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc:
        'Nuorodos Adreso Priklausomas Grintinio Kelio Aprašymas',
    EXTRACTED_FIELDS_RefAddressSubBuildingNumber:
        'Nuorodos adreso papildomas pastato numeris',
    EXTRACTED_FIELDS_AddressSubBuildingNumber: 'Pastato numeris',
    EXTRACTED_FIELDS_AddressSubBuildingName: 'Pastato pavadinimas',
    EXTRACTED_FIELDS_AddressPostCodeType: 'Pašto kodo tipas',
    EXTRACTED_FIELDS_IssuingAuthorityType: 'Išdavimo institucijos tipas',
    EXTRACTED_FIELDS_Signature: 'Parašas',
    EXTRACTED_FIELDS_Hologram: 'Hologram',
    EXTRACTED_FIELDS_CardNumber: 'Kortelės numeris',
    EXTRACTED_FIELDS_MiddleNameInitial: 'Vidurinė vardo pradžioji.',
    EXTRACTED_FIELDS_PermitNumber: 'Leidimo numeris',
    EXTRACTED_FIELDS_ReferenceNumber: 'Nuorodos numeris',
    EXTRACTED_FIELDS_CustomerNumber: 'Kliento numeris',
    EXTRACTED_FIELDS_BOSNumber: 'BOS Numeris',
    EXTRACTED_FIELDS_StudentID: 'Studento identifikacinis numeris',
    EXTRACTED_FIELDS_MembershipNumber: 'Nario numeris',
    EXTRACTED_FIELDS_LicenseType: 'Licencijos tipas',
    EXTRACTED_FIELDS_LicenseType2: 'Licencijos tipas 2',
    EXTRACTED_FIELDS_LicenseType3: 'Licencijos tipas 3',
    EXTRACTED_FIELDS_LicenseType4: 'Licencijos tipas 4',
    EXTRACTED_FIELDS_DocumentTypeCode: 'Dokumento tipo kodas',
    EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit: 'MRZ Patikrinimo skaitmuo',
    EXTRACTED_FIELDS_MRZBirthDateCheckDigit:
        'Gimimo datos kontrolinis skaičius MRZ',
    EXTRACTED_FIELDS_MRZExpiryDateCheckDigit:
        'MRZ Galiojimo pabaigos datos kontrolinis skaitmuo',
    EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit:
        'MRZ Asmens numerio tikrinimo skaitmuo',
    EXTRACTED_FIELDS_MRZCompositeCheckDigit:
        'MRZ Kompozicinis Patikrinimo Skaitmuo',
    EXTRACTED_FIELDS_SecondaryPortraitPhoto: 'Antrinis portretinis nuotrauka',
    EXTRACTED_FIELDS_Fingerprint: 'pirštų atspaudas',
    EXTRACTED_FIELDS_VersionNumber: 'Versijos numeris',
    EXTRACTED_FIELDS_Conditions: 'Sąlygos',
    EXTRACTED_FIELDS_NickName: 'Slapyvardis',
    EXTRACTED_FIELDS_AddressApartmentNumber: 'Butas numeris',
    EXTRACTED_FIELDS_AddressFloorNumber: 'Aukšto numeris',
    EXTRACTED_FIELDS_FirstNameLocal: 'Pirmas Vardas Vietinis',
    EXTRACTED_FIELDS_LastNameLocal: 'Pavardė Vietinė',
    EXTRACTED_FIELDS_FullNameLocal: 'Pilnas vardas Vietinis',
    EXTRACTED_FIELDS_BirthPlaceLocal: 'Gimimo vieta vietinis',
    EXTRACTED_FIELDS_IssuingAuthorityLocal: 'Išdavimo institucija Vietinis',
    EXTRACTED_FIELDS_MotherNameLocal: 'Mamos Vardas Vietinis',
    EXTRACTED_FIELDS_FatherNameLocal: 'Tėvo Vardas Vietinis',
    EXTRACTED_FIELDS_AddressFullLocal: 'Adresas Pilnas Vietinis',
    EXTRACTED_FIELDS_MiddleNameLocal: 'Vardas Tėvo',
    EXTRACTED_FIELDS_AddressLine1Local: 'Adreso eilutė 1 Vietinis',
    EXTRACTED_FIELDS_AddressLine2Local: 'Adreso eilutė 2 Vietinis',
    EXTRACTED_FIELDS_AddressLine3Local: 'Adreso eilutė3 Vietinis',
    EXTRACTED_FIELDS_IndRefNumber1: 'Individualus nuorodos numeris 1',
    EXTRACTED_FIELDS_IndRefNumber2: 'Individualus nuorodos numeris 2',
    EXTRACTED_FIELDS_IndRefNumber3: 'Individualus nuorodos numeris 3',
    EXTRACTED_FIELDS_IndRefNumber4: 'Individualus nuorodos numeris 4',
    EXTRACTED_FIELDS_IndRefNumber5: 'Individualus nuorodos numeris 5',
    EXTRACTED_FIELDS_Name1: 'Vardas 1',
    EXTRACTED_FIELDS_Name2: 'Vardas 2',
    EXTRACTED_FIELDS_Name3: 'Vardas 3',
    EXTRACTED_FIELDS_Name4: 'Vardas 4',
    EXTRACTED_FIELDS_Name5: 'Vardas 5',
    EXTRACTED_FIELDS_RECIPIENT_NAME_1: 'Gavėjo pavadinimas 1',
    EXTRACTED_FIELDS_RECIPIENT_NAME_2: 'Gavėjo pavadinimas 2',
    EXTRACTED_FIELDS_RECIPIENT_NAME_3: 'Gavėjo vardas ir pavardė 3',
    EXTRACTED_FIELDS_RECIPIENT_NAME_4: 'Gavėjo vardas ir pavardė 4',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL: 'Gavėjo adresas Visas',
    EXTRACTED_FIELDS_IBAN: 'IBAN Sąskaitos numeris',
    EXTRACTED_FIELDS_ACCOUNT_NUM: 'Sąskaitos numeris',
    EXTRACTED_FIELDS_ISSUER: 'Emitentas',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY: 'Gavėjo adresas Miestas',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE: 'Gavėjo adresas Pašto kodas',
    EXTRACTED_FIELDS_DAY: 'Diena',
    EXTRACTED_FIELDS_MONTH: 'Mėnuo',
    EXTRACTED_FIELDS_YEAR: 'Metai',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_1: 'Neprivaloma reikšmė 1',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_2: 'Neprivaloma reikšmė 2',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_3: 'Neprivaloma reikšmė 3',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_4: 'Neprivaloma 4 reikšmė',
    EXTRACTED_FIELDS_ISSUING_STATE_NAME:
        'Išduodančiosios valstybės pavadinimas',
    EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID:
        'Priekinės pusės dokumento tipas Id',
    EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID: 'Backside Document Type Id',
    HASNOCAMERA_TITLE:
        'Oops, negalėjome atpažinti jūsų įrenginyje esančios kameros!',
    HASNOCAMERA_DESCRIPTION:
        'Atrodo, kad jūsų įrenginyje nėra fotoaparato, bandykite dar kartą kitame įrenginyje, kuriame yra veikiantis fotoaparatas, kad galėtumėte atlikti visus reikiamus veiksmus.',
    EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT: 'Covid Type Id',
    USER_INPUT_FIRST_NAME: 'Vardas ir pavardė',
    USER_INPUT_MIDDLE_NAME: 'Vidurinysis vardas',
    USER_INPUT_LAST_NAME: 'Pavardė',
    USER_INPUT_DOB: 'Gimimo data',
    USER_INPUT_HOUSE_NAME_NUMBER: 'Namo pavadinimas/numeris*',
    USER_INPUT_STREET_NAME: 'Gatvės pavadinimas*',
    USER_INPUT_TOWN: 'Miestas*',
    USER_INPUT_POSTAL_CODE: 'Pašto kodas*',
    USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE: 'pvz., Namas/35',
    USER_INPUT_STREET_NAME_EXAMPLE: 'pvz., Testo gatvė',
    USER_INPUT_TOWN_EXAMPLE: 'pvz., Somewhere',
    USER_INPUT_POSTAL_CODE_EXAMPLE: 'pvz., CH496 (be tarpų)',
    SYSTEM_NOT_ABLE: 'Sistema negalėjo nuskaityti dokumento',
    TRY_AGAIN: 'Pabandykite dar kartą',
    HINTS_DISABLED_HEADER: 'Patarimai išjungti rankiniu režimu',
    HINTS_DISABLED_DESCRIPTION:
        'Jei norite įjungti patarimus nuotraukai padaryti, perjunkite į AUTOMATINIO FOTOGRAFAVIMO režimą',
    YOU_HAVE: 'Jūs turite',
    PICTURE_VERIFYING: 'Tikrinama...',
    HOW_TO_TAKE_PHOTO_CORRECTLY: 'Kaip teisingai padaryti nuotrauką',
};
